import { modalTypes } from "constants/types";
import { pick } from "lodash";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideModal, showModal } from "slices/app/actions/modals";
import { cloneWatchwordsList } from "slices/watchwords/edit/actions";

const useCloneWatchwordsListHandler = (watchwordsList) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { name } = watchwordsList || {};

  const onConfirmDuplicate = async (newName) => {
    const cloned = pick(watchwordsList, ["categories", "description"]);
    cloned.name = newName;

    const rsp = await dispatch(cloneWatchwordsList(cloned));
    const newId = rsp?.payload?.data?.id;

    if (newId) {
      navigate(`/watchwords/${newId}`);
    }

    dispatch(hideModal(modalTypes.TEXT_FIELD_MODAL));
  };

  return useCallback(() => {
    dispatch(
      showModal(modalTypes.TEXT_FIELD_MODAL, {
        inputText: `${name} (copy)`,
        subHeading: "New Watchwords List name: ",
        title: "Clone Watchwords List",
        placeholderText: "Watchwords List name",
        buttonText: "Save",
        errorMessage: "",
        onOk: onConfirmDuplicate,
        selectTextOnInitialLoad: true,
      })
    );
  }, [watchwordsList]);
};

export default useCloneWatchwordsListHandler;
